import { useState, useEffect, Fragment } from "react";
import { fieldType } from "../../../../types/form";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { siteUrl } from "../../../../constants";
import Loading from "src/components/Loading";
import { getItemsRequest } from "src/modules/spItems/api";
import { equipmentsListName } from "src/api/config";

type Props = {
  dataField: fieldType;
  onChange: (data: any) => void;
  value: any;
  errors?: any;
};

export default function Autocomplete(props: Props) {
  const { dataField, onChange, value, errors } = props;
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchResults, setSearchResults] = useState<any>([]);

  useEffect(() => {
    if (query.length >= 3) {
      setLoading(true);
      let re = /[()]/gi;
      let clearQuery = query.replace(re, "").toUpperCase();
      getItemsRequest({
        listName: equipmentsListName,
        filters: { SAP: `${clearQuery}*` },
        rowLimit: 100,
        sortOrder: { name: "ID", asc: true },
      }).then((results) => {
        setSearchResults(
          results.items.map((item: any) => {
            return {
              id: Number(item.ID),
              name: item.SAP,
              ID: Number(item.ID),
              Title: item.Title,
              SAP: item.SAP,
              Manufacturer: item.Manufacturer,
              Model: item.Model,
              TypeEquipment: item.TypeEquipment,
            };
          })
        );
        setLoading(false);
      });
    }
  }, [query]);

  return (
    <div className={`${dataField.width} mb-5 custom-form`}>
      <Combobox
        disabled={dataField.disabled}
        defaultValue={value}
        onChange={onChange}
      >
        <Combobox.Label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
          <span>{dataField.title}</span>
          {dataField.require && (
            <div className="flex flex-row justify-between">
              {Object.keys(errors).length > 0 && errors[dataField.key] && (
                <span className="text-[#BA0C2F]">Заполните поле&nbsp;</span>
              )}
              <span className="text-[#BA0C2F]">*</span>
            </div>
          )}
        </Combobox.Label>
        <div className="relative mt-2">
          <Combobox.Input
            className="bg-white text-left cursor-default block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB]"
            displayValue={(value: any) => value && value.name}
            onChange={(event) => setQuery(event.target.value)}
            placeholder={dataField.placeholder}
          />
          <Combobox.Button className="pointer-events-none absolute inset-y-0 right-[20px] top-0 flex items-center pr-2">
            {(!loading && (
              <MagnifyingGlassIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            )) || <Loading />}
          </Combobox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery("")}
          >
            <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
              {searchResults.length === 0 && query !== "" ? (
                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                  Нет совпадений
                </div>
              ) : (
                searchResults.map((item: any) => (
                  <Combobox.Option
                    key={item.id}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-10 pr-4 ${
                        active ? "bg-darkblue text-white" : "text-gray-900"
                      }`
                    }
                    value={item}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selected ? "font-medium" : "font-normal"
                          }`}
                        >
                          {item.name}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                              active ? "text-white" : "text-teal-600"
                            }`}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
}
